<template>
  <LeftTeaser :title="title" :subtitles="subtitles" :benefits="benefits" />
</template>

<script>
import LeftTeaser from '@/components/auth/left/LeftTeaser.vue'
import { $t } from '@/composables/translation'

export default {
  name: 'LeftRegisterFreelancer',
  components: {
    LeftTeaser,
  },
  setup() {
    return {
      title: $t('Work on your terms'),
      subtitles: [
        $t('Find high quality work and take your freelance career to the next level.'),
        $t(
          'With Worksome, you can review & accept contracts, submit bills, and get paid faster, so that you can:',
        ),
      ],
      benefits: [
        $t('Start projects you love sooner'),
        $t('Have less paperwork'),
        $t('Focus on the actual work'),
      ],
    }
  },
}
</script>
